var _rect, _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 110,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 55,
    r: 48,
    fill: "url(#paint0_radial_1488_13264)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.4833 72.0148L64.5155 84.1655L69.7711 78.6453C70.5089 77.8708 71.0113 77.051 71.2389 76.2459L74.1073 66.1563C74.725 63.9829 73.3229 62.1578 70.5168 61.4825L60.4833 72.0148Z",
    fill: "url(#paint1_linear_1488_13264)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9812 54.3903L29.6455 50.9553L34.9011 45.435C35.6389 44.6606 36.4321 44.119 37.2275 43.8549L47.1651 40.4965C49.3031 39.7732 51.1957 41.0875 52.0091 43.8565L41.9812 54.3903Z",
    fill: "url(#paint2_linear_1488_13264)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M37.819 85.9969C33.4093 90.6245 19.9183 100.89 17.5148 98.6024C15.1113 96.3146 24.7111 82.3433 29.1222 77.7102C33.0063 73.637 35.8891 74.5097 38.2871 76.796C40.6906 79.0837 41.6989 81.9168 37.819 85.9969Z",
    fill: "url(#paint3_linear_1488_13264)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2727,
    d: "M37.64 85.7192C33.3357 90.2395 20.0562 100.485 17.7846 98.3212C15.5129 96.1571 25.1037 82.3955 29.408 77.8752C33.1966 73.8943 35.9523 74.6916 38.2295 76.8571C40.5011 79.0212 41.4286 81.7383 37.64 85.7192Z",
    fill: "url(#paint4_linear_1488_13264)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3455,
    d: "M37.4611 85.4415C33.2622 89.8545 20.1997 100.082 18.0543 98.04C15.909 95.9981 25.4948 82.4531 29.6937 78.0401C33.3909 74.1585 36.0195 74.8805 38.1649 76.9223C40.3102 78.9642 41.1583 81.5598 37.4611 85.4415Z",
    fill: "url(#paint5_linear_1488_13264)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4182,
    d: "M37.2822 85.1638C33.1845 89.4625 20.3376 99.6769 18.3186 97.7573C16.2996 95.8376 25.8803 82.5093 29.978 78.2105C33.5838 74.4281 36.0867 75.0693 38.1043 76.9944C40.1248 78.9086 40.8895 81.3758 37.2822 85.1638Z",
    fill: "url(#paint6_linear_1488_13264)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4909,
    d: "M37.1032 84.8861C33.1109 89.0775 20.4756 99.272 18.5884 97.4761C16.7012 95.6802 26.2729 82.5615 30.2637 78.3755C33.7796 74.6868 36.154 75.2582 38.0412 77.0541C39.9339 78.8515 40.6191 81.1974 37.1032 84.8861Z",
    fill: "url(#paint7_linear_1488_13264)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5636,
    d: "M36.9243 84.6083C33.0388 88.687 20.619 98.8685 18.8596 97.1893C17.1002 95.5101 26.6654 82.6136 30.5509 78.5349C33.9699 74.9439 36.2241 75.436 37.9835 77.1152C39.7444 78.7889 40.3488 81.0188 36.9243 84.6083Z",
    fill: "url(#paint8_linear_1488_13264)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6364,
    d: "M36.7454 84.3306C32.9652 88.302 20.757 98.4636 19.1239 96.9066C17.4908 95.3497 27.051 82.6698 30.8311 78.6984C34.1587 75.2066 36.2859 75.6234 37.9189 77.1804C39.5535 78.7319 40.0745 80.8334 36.7454 84.3306Z",
    fill: "url(#paint9_linear_1488_13264)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7091,
    d: "M36.5665 84.0529C32.8876 87.9101 20.9004 98.0602 19.3937 96.6255C17.8924 95.1922 27.4435 82.7219 31.1169 78.8633C34.3545 75.4653 36.3546 75.8068 37.8558 77.2401C39.3681 78.6763 39.8041 80.6549 36.5665 84.0529Z",
    fill: "url(#paint10_linear_1488_13264)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7818,
    d: "M36.3876 83.7752C32.814 87.5251 21.0384 97.6553 19.6634 96.3443C18.2885 95.0332 27.8346 82.7796 31.4081 79.0297C34.5544 75.731 36.4273 75.9972 37.8022 77.3082C39.1772 78.6193 39.5338 80.4765 36.3876 83.7752Z",
    fill: "url(#paint11_linear_1488_13264)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8545,
    d: "M36.2141 83.499C32.7474 87.136 21.1818 97.2519 19.9387 96.0645C18.6901 94.8757 28.2312 82.8387 31.6994 79.1961C34.7502 75.9897 36.5 76.1875 37.7446 77.3694C38.9877 78.5567 39.265 80.2925 36.2141 83.499Z",
    fill: "url(#paint12_linear_1488_13264)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9273,
    d: "M36.0352 83.2212C32.6738 86.751 21.3253 96.8484 20.203 95.7818C19.0807 94.7152 28.6182 82.8894 31.9796 79.3596C34.939 76.2523 36.5577 76.3679 37.68 77.4345C38.7968 78.4997 38.9946 80.114 36.0352 83.2212Z",
    fill: "url(#paint13_linear_1488_13264)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8563 82.9435C32.6002 86.366 21.4632 96.4435 20.4728 95.5006C19.4823 94.5577 29.0093 82.9471 32.2653 79.5245C35.1334 76.5165 36.6249 76.5568 37.6154 77.4997C38.6114 78.4441 38.7188 79.934 35.8563 82.9435Z",
    fill: "url(#paint14_linear_1488_13264)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5257 79.1011L35.7337 71.6813L34.6855 72.7791C34.677 72.7886 34.6631 72.7966 34.6532 72.8117C33.4574 74.0643 34.2364 76.7416 36.3858 78.7904C38.5352 80.8393 41.2493 81.484 42.4451 80.2314C42.4536 80.2219 42.4635 80.2069 42.4719 80.1973L43.5257 79.1011Z",
    fill: "url(#paint15_linear_1488_13264)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2134 74.5056L39.604 56.7757L34.3344 62.304L34.3399 62.3055C34.316 62.3285 34.2922 62.3516 34.2668 62.3801C31.4142 65.3746 33.271 71.7696 38.4108 76.6641C43.5506 81.5586 50.0251 83.099 52.8763 80.1101C52.9002 80.087 52.92 80.057 52.9438 80.0339L52.9493 80.0354L58.2134 74.5056Z",
    fill: "url(#paint16_linear_1488_13264)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M58.0321 74.6985L39.4227 56.9686L35.2252 61.3761L35.2307 61.3776C35.2138 61.3966 35.1914 61.4142 35.169 61.4318C32.8981 63.8162 35.2159 69.722 40.3557 74.6165C45.4956 79.511 51.5021 81.5447 53.773 79.1602C53.7899 79.1412 53.8082 79.1166 53.8251 79.0976L53.8306 79.0991L58.0321 74.6985Z",
    fill: "#AFB6E5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8913 61.1988C89.3453 54.2083 95.1651 44.45 96.8783 33.6148C96.9521 33.1633 97.0164 32.7033 97.0738 32.2474L99.6934 12.3346L79.929 15.9115C79.4762 15.9963 79.0234 16.0812 78.5731 16.1786C67.8329 18.4205 58.3665 24.7037 51.7957 33.4832L36.5425 53.8874L36.5465 53.8944C36.5142 53.927 36.4764 53.9581 36.4496 53.9921C32.6625 57.9676 35.1245 66.4572 41.9545 72.9593C48.7791 79.46 57.3792 81.511 61.1663 77.5356C61.1986 77.503 61.2254 77.469 61.2591 77.4309L61.2632 77.4379L80.8913 61.1988Z",
    fill: "url(#paint17_linear_1488_13264)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0793 32.2489L99.6934 12.3346L79.929 15.9115C79.8183 15.929 79.7101 15.9589 79.5994 15.9764C79.2295 19.3356 81.2832 23.8745 85.1689 27.5787C89.0601 31.2843 93.6911 33.1085 97.0254 32.582C97.0439 32.4691 97.0663 32.3632 97.0793 32.2489Z",
    fill: "url(#paint18_linear_1488_13264)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8402 50.4265C58.2102 52.1343 56.4696 52.7814 54.9538 52.4578C54.9098 52.446 53.4776 52.1624 53.4336 52.1506C51.9065 51.7591 53.7509 51.0985 53.0692 48.7831C51.6968 44.1204 53.2865 37.5059 56.6156 34.0087C58.2625 32.2819 56.6774 30.7437 58.2078 31.1007C58.2518 31.1125 59.9024 31.5489 59.9463 31.5606C61.451 31.9697 62.7155 33.3631 63.3921 35.6536C64.759 40.3148 63.1693 46.9293 59.8402 50.4265Z",
    fill: "url(#paint19_linear_1488_13264)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1379 50.0294C54.8019 53.5306 50.9898 52.5858 49.6174 47.9231C48.2451 43.2603 49.8348 36.6459 53.1638 33.1486C56.4929 29.6514 60.3049 30.5963 61.6773 35.259C63.0567 39.9176 61.467 46.5321 58.1379 50.0294Z",
    fill: "url(#paint20_linear_1488_13264)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6677 48.4422C54.9626 51.2818 51.8681 50.5174 50.7501 46.7301C49.6377 42.9442 50.9235 37.5739 53.6341 34.7357C56.3392 31.8962 59.4337 32.6605 60.5516 36.4479C61.664 40.2338 60.3727 45.6026 57.6677 48.4422Z",
    fill: "url(#paint21_linear_1488_13264)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0846 46.1384C56.0512 48.2742 53.7198 47.6967 52.88 44.8499C52.0418 41.9976 53.0125 37.9569 55.046 35.8211C57.0794 33.6852 59.4108 34.2628 60.2506 37.1096C61.0903 39.9564 60.1236 44.0041 58.0846 46.1384Z",
    fill: "url(#paint22_linear_1488_13264)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9846 47.2022C50.8721 43.4163 52.1634 38.0475 54.8685 35.2079C56.115 33.8981 57.4438 33.3587 58.6254 33.5221C57.2027 32.5871 55.3401 32.9423 53.6341 34.7357C50.929 37.5753 49.6377 42.9442 50.7501 46.7301C51.3522 48.7708 52.5253 49.9335 53.9053 50.1265C53.0793 49.5812 52.4001 48.5979 51.9846 47.2022Z",
    fill: "url(#paint23_linear_1488_13264)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9808 35.2696C61.324 33.0374 59.7571 31.6513 58.7454 31.3154C59.9111 31.9342 61.0638 33.3271 61.6227 35.2208C62.9951 39.8835 61.4054 46.498 58.0764 49.9952C56.3395 51.8157 54.2853 52.314 52.7005 51.8304C54.2217 52.4855 56.4572 52.1242 58.4399 50.0455C61.7635 46.5468 63.3532 39.9323 61.9808 35.2696Z",
    fill: "url(#paint24_radial_1488_13264)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8703 62.041L16.477 68.3066L15.9024 66.2732L20.9345 60.9935C21.64 60.2517 22.5514 59.5768 23.6115 59.0066L36.8425 51.888C39.6912 50.3595 43.2305 49.7937 45.9197 50.4436L46.458 52.4142L34.8703 62.041Z",
    fill: "url(#paint25_linear_1488_13264)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4448 64.0744L16.477 68.3066L21.5091 63.0269C22.2145 62.2851 23.1259 61.6102 24.186 61.0399L37.4171 53.9214C40.2658 52.3929 43.805 51.8271 46.4942 52.477L35.4448 64.0744Z",
    fill: "url(#paint26_linear_1488_13264)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4883 63.2806C22.1937 62.5387 23.1051 61.8638 24.1652 61.2936L37.3963 54.1751C40.1155 52.712 43.47 52.132 46.1062 52.6499L46.4083 52.3361C43.7246 51.6877 40.1798 52.252 37.3311 53.7805L24.1001 60.8991C23.04 61.4693 22.1271 62.1497 21.4231 62.886L16.391 68.1657L16.9494 68.0385L21.4883 63.2806Z",
    fill: "url(#paint27_radial_1488_13264)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M53.189 79.4927L47.8197 98.1679L49.8782 98.6429L54.9103 93.3632C55.6158 92.6214 56.2515 91.6782 56.7667 90.5908L63.2344 77.0292C64.6294 74.1096 65.0193 70.5436 64.2384 67.8953L62.2414 67.4544L53.189 79.4927Z",
    fill: "url(#paint28_linear_1488_13264)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1305 79.0177L47.8197 98.1679L52.8518 92.8882C53.5573 92.1464 54.193 91.2032 54.7082 90.1158L61.1759 76.5542C62.5709 73.6346 62.9608 70.0687 62.1799 67.4203L51.1305 79.0177Z",
    fill: "url(#paint29_linear_1488_13264)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8821 90.2802L61.3498 76.7186C62.7448 73.799 63.1348 70.233 62.3538 67.5847L62.2892 67.6498C62.8382 70.2184 62.4029 73.4482 61.1236 76.1337L54.6559 89.6952C54.1352 90.7812 53.505 91.7258 52.7996 92.4677L48.1679 97.3303L47.9936 98.3323L53.0258 93.0526C53.7312 92.3108 54.3614 91.3661 54.8821 90.2802Z",
    fill: "url(#paint30_radial_1488_13264)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1488_13264",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55 55) rotate(90) scale(48)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ED0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1488_13264",
    x1: 66.0411,
    y1: 87.8371,
    x2: 67.956,
    y2: 60.1687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6148E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    stopColor: "#7159EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4192,
    stopColor: "#7B64F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5954,
    stopColor: "#8A66F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9353,
    stopColor: "#B36CF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB6DF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1488_13264",
    x1: 51.6286,
    y1: 63.264,
    x2: 30.5989,
    y2: 31.7937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6148E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    stopColor: "#7159EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4192,
    stopColor: "#7B64F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5954,
    stopColor: "#8A66F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9353,
    stopColor: "#B36CF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB6DF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1488_13264",
    x1: 35.5878,
    y1: 79.6291,
    x2: 21.2232,
    y2: 94.7068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1454,
    stopColor: "#FF866F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3616,
    stopColor: "#FF6A70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5776,
    stopColor: "#FF5571"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7913,
    stopColor: "#FF4972"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4572"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1488_13264",
    x1: 35.5698,
    y1: 79.648,
    x2: 21.4331,
    y2: 94.4864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0714,
    stopColor: "#FF9A71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3166,
    stopColor: "#FF7B72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#FF6673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7882,
    stopColor: "#FF5874"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5474"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1488_13264",
    x1: 35.5517,
    y1: 79.667,
    x2: 21.643,
    y2: 94.2662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAB72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2669,
    stopColor: "#FF8C73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.534,
    stopColor: "#FF7574"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7845,
    stopColor: "#FF6775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6275"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1488_13264",
    x1: 35.5336,
    y1: 79.6861,
    x2: 21.8529,
    y2: 94.0457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB174"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1839,
    stopColor: "#FF9E75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4918,
    stopColor: "#FF8576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7728,
    stopColor: "#FF7677"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1488_13264",
    x1: 35.5155,
    y1: 79.705,
    x2: 22.0628,
    y2: 93.8254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0854,
    stopColor: "#FFB076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4426,
    stopColor: "#FF9578"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7591,
    stopColor: "#FF8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7F79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1488_13264",
    x1: 35.4975,
    y1: 79.7239,
    x2: 22.2727,
    y2: 93.6051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBE78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3563,
    stopColor: "#FFA679"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7308,
    stopColor: "#FF947B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8E7B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1488_13264",
    x1: 35.4794,
    y1: 79.7429,
    x2: 22.4827,
    y2: 93.3847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC57B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2461,
    stopColor: "#FFB77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6955,
    stopColor: "#FFA37C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1488_13264",
    x1: 35.4614,
    y1: 79.7618,
    x2: 22.6926,
    y2: 93.1644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCB7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0349,
    stopColor: "#FFC97D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#FFB37E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAB7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1488_13264",
    x1: 35.4433,
    y1: 79.7808,
    x2: 22.9024,
    y2: 92.9441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD27F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5194,
    stopColor: "#FFC280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB980"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1488_13264",
    x1: 35.4253,
    y1: 79.7997,
    x2: 23.1123,
    y2: 92.7238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2547,
    stopColor: "#FFD381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC882"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1488_13264",
    x1: 35.4071,
    y1: 79.8187,
    x2: 23.3223,
    y2: 92.5033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDF83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD683"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1488_13264",
    x1: 35.3891,
    y1: 79.8376,
    x2: 23.5322,
    y2: 92.2831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE585"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1488_13264",
    x1: 41.2571,
    y1: 73.7076,
    x2: 35.6844,
    y2: 79.4806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00505051,
    stopColor: "#273B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2274,
    stopColor: "#2F2BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399,
    stopColor: "#361CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.768,
    stopColor: "#440B89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1488_13264",
    x1: 34.446,
    y1: 62.3741,
    x2: 52.7596,
    y2: 79.8218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#676FAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0484,
    stopColor: "#757CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1061,
    stopColor: "#8B92C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2273,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3489,
    stopColor: "#949BCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3788,
    stopColor: "#8D94C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    stopColor: "#5E67A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6122,
    stopColor: "#616AAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6703,
    stopColor: "#6C75B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7249,
    stopColor: "#7E86BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7774,
    stopColor: "#979ED1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7778,
    stopColor: "#979ED1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7179B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1488_13264",
    x1: 56.1743,
    y1: 28.6891,
    x2: 85.2825,
    y2: 56.4208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0101,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0661,
    stopColor: "#D8DCF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1615,
    stopColor: "#F3F4FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.197,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2734,
    stopColor: "#F5F7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3586,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3876,
    stopColor: "#DBDFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4705,
    stopColor: "#C3C9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5472,
    stopColor: "#B4BBE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6111,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7831,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CED3F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1488_13264",
    x1: 88.4299,
    y1: 12.988,
    x2: 97.8533,
    y2: 33.8233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#836DF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0474,
    stopColor: "#8A6DF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1181,
    stopColor: "#9F6DF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#BB6DF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3434,
    stopColor: "#6B54DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4976,
    stopColor: "#7760E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7178,
    stopColor: "#806AF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#836DF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1488_13264",
    x1: 60.7932,
    y1: 31.6141,
    x2: 55.6486,
    y2: 52.8586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#676FAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0484,
    stopColor: "#757CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1061,
    stopColor: "#8B92C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2273,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3489,
    stopColor: "#949BCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3788,
    stopColor: "#8D94C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    stopColor: "#5E67A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6122,
    stopColor: "#616AAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6703,
    stopColor: "#6C75B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7249,
    stopColor: "#7E86BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7774,
    stopColor: "#979ED1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7778,
    stopColor: "#979ED1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7179B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1488_13264",
    x1: 50.1346,
    y1: 36.3322,
    x2: 61.1704,
    y2: 46.8461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#929AD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3636,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6144,
    stopColor: "#949CD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#646EB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1488_13264",
    x1: 53.7729,
    y1: 35.4726,
    x2: 58.1791,
    y2: 49.8111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00505051,
    stopColor: "#66CCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1323,
    stopColor: "#62BCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.379,
    stopColor: "#5993FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5303,
    stopColor: "#5277F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E34C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1488_13264",
    x1: 57.4552,
    y1: 31.0012,
    x2: 56.3214,
    y2: 43.7751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1488_13264",
    x1: 51.6488,
    y1: 49.5279,
    x2: 55.707,
    y2: 32.7697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#676FAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0484,
    stopColor: "#757CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1061,
    stopColor: "#8B92C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2273,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3489,
    stopColor: "#949BCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3788,
    stopColor: "#8D94C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    stopColor: "#5E67A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6122,
    stopColor: "#616AAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6703,
    stopColor: "#6C75B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7249,
    stopColor: "#7E86BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7774,
    stopColor: "#979ED1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7778,
    stopColor: "#979ED1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7179B5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_1488_13264",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.8826 42.4699) rotate(43.6127) scale(8.1783)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1488_13264",
    x1: 19.2154,
    y1: 65.92,
    x2: 48.9519,
    y2: 49.9131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5129C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1598,
    stopColor: "#5D41D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.197,
    stopColor: "#6047DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3926,
    stopColor: "#7962ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4646,
    stopColor: "#836DF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5139,
    stopColor: "#896DF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5783,
    stopColor: "#996DF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6508,
    stopColor: "#B46DF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6667,
    stopColor: "#BB6DF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.803,
    stopColor: "#A959E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1488_13264",
    x1: 22.3332,
    y1: 55.7407,
    x2: 55.8376,
    y2: 72.7702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6148E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    stopColor: "#7159EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4192,
    stopColor: "#7B64F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5954,
    stopColor: "#8A66F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9353,
    stopColor: "#B36CF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB6DF3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_1488_13264",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.3121 62.6158) rotate(43.6084) scale(11.9973)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1488_13264",
    x1: 54.7377,
    y1: 85.7354,
    x2: 62.2698,
    y2: 69.5354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5129C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1598,
    stopColor: "#5D41D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.197,
    stopColor: "#6047DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3926,
    stopColor: "#7962ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4646,
    stopColor: "#836DF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5139,
    stopColor: "#896DF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5783,
    stopColor: "#996DF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6508,
    stopColor: "#B46DF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6667,
    stopColor: "#BB6DF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.803,
    stopColor: "#A959E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1488_13264",
    x1: 49.5911,
    y1: 101.766,
    x2: 61.7466,
    y2: 58.0737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6148E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    stopColor: "#7159EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4192,
    stopColor: "#7B64F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5954,
    stopColor: "#8A66F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9353,
    stopColor: "#B36CF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB6DF3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_1488_13264",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.4369 75.7821) rotate(43.6127) scale(11.9976)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.bf6a6555a33ca1556fea5ae927a047aa.svg";
export { ForwardRef as ReactComponent };